// const appConfig = {
//   env: "dev",
//   baseApiUrl: "https://qa.paythat.co.za",
//   clientSecret: "nNoQoBW1ssVstyVVnHiqGVFo9PxG5PSUOWWlEkbU",
//   clientID: "2",
//   scope: "2",
//   recaptchaSiteKey: "6Lc4WNUgAAAAAJP_otZ6QQFo1f4Fp-BXnDRce-rb",
//   recpatchaSiteKeyv2: "6Lfa1gclAAAAAFFYWJAj7pqJv6gsnSif2-JNDLUv",
//   recaptchaSecretKey: "6Lc4WNUgAAAAAFAjYNT6G4Z6_wSZKqcQQ6MxiPde",
//   howToVideoURL: "https://www.youtube.com/embed/FCEO-EJBo58",
// };
const appConfig = {
  baseApiUrl: "https://prod.paythat.co.za",
  clientSecret: "uNwy92xAkmN62XGHZUrTttGzg7gBDoGWINeOAedX",
  clientID: "2",
  scope: "2",
  recaptchaSiteKey: "6Lc4WNUgAAAAAJP_otZ6QQFo1f4Fp-BXnDRce-rb",
  recpatchaSiteKeyv2: "6Lfa1gclAAAAAFFYWJAj7pqJv6gsnSif2-JNDLUv",
  recaptchaSecretKey: "6Lc4WNUgAAAAAFAjYNT6G4Z6_wSZKqcQQ6MxiPde",
  howToVideoURL: "https://www.youtube.com/embed/FCEO-EJBo58",
};

export default appConfig;
